import Image from "next/image";
import bg from "public/images/death.webp";
import type { FallbackProps } from "react-error-boundary";

// import { Button } from '~/components/atoms/Button';
import { Button, ExternalLink, H1 } from "@sorcery/ui";

const reactDomGoogleTranslateError =
  "Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.";

// biome-ignore lint/suspicious/noShadowRestrictedNames: <explanation>
export const Error = ({ error }: FallbackProps) => {
  // biome-ignore lint/style/noRestrictedGlobals: <explanation>
  const message = (window as any)?.skew ? (
    <>
      <H1>Out of sync</H1>
      <div className="mb-2 text-base">
        <span>
          An issue has occurred as the Sorcery website has been updated! Please reload the page. If
          the issue persists and you'd like to get in touch, please reach out on our
        </span>
        <ExternalLink
          href="https://discord.gg/mWFU7WK5rm"
          target="_blank"
          rel="noreferrer"
          color="primary"
        >
          {" "}
          discord server.
        </ExternalLink>
        <span>.</span>
      </div>
    </>
  ) : (
    <>
      <H1>Error</H1>
      <div className="mb-2">
        {error?.message.includes(reactDomGoogleTranslateError) ? (
          <span>
            It looks like your Google Translate Extension is playing up and causing the site to
            crash. Try disabling it and reloading the page.
          </span>
        ) : (
          <span>
            <span>
              Looks like the site exploded. We've been alerted but if you'd like to get in touch,
              please reach out on our
            </span>
            <ExternalLink
              href="https://discord.gg/mWFU7WK5rm"
              target="_blank"
              rel="noreferrer"
              color="primary"
            >
              {" "}
              discord server.
            </ExternalLink>
          </span>
        )}
        <span>.</span>
      </div>
    </>
  );
  return (
    <div className="container mx-auto h-[80vh] p-4">
      <div className="flex h-full flex-row items-center justify-center">
        <div className="mr-6 hidden max-w-xs md:block">
          <Image src={bg} width={559} height={826} alt="" placeholder="blur" />
        </div>

        <div className="max-w-md">
          {message}

          <div className="text-red my-4" role="alert">
            <p>
              <span className="font-bold">Error. </span>
              {error?.message ?? <span>Unknown error occurred</span>}
              <span>.</span>
            </p>
          </div>

          <Button
            onClick={() => {
              // biome-ignore lint/style/noRestrictedGlobals: <explanation>
              window?.location.reload();
            }}
          >
            Reload
          </Button>
        </div>
      </div>
    </div>
  );
};
